export default __webpack_public_path__ + "static/media/MID BASELINES.36630dd4.xlsx";